import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
        this.handleReload = this.handleReload.bind(this);
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error('Erreur non gérée dans l\'application :', error, info);
    }

    handleReload() {
        this.setState({ hasError: false });
        window.location.href = '/';
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="vertical iCenter jCenter" style={{ minHeight: '100vh', textAlign: 'center', padding: '0 24px' }}>
                    <p className="txt18 medium noMrgB">Une erreur est survenue</p>
                    <p className="dGreyT noMrgT mrgB20">Veuillez réessayer. Si le problème persiste, contactez-nous via contact@boldee.co</p>
                    <button
                        className="btnReset"
                        style={{ padding: '10px 24px', borderRadius: 999, cursor: 'pointer', backgroundColor: '#1c1c1c', color: '#fff', fontWeight: 600 }}
                        onClick={this.handleReload}
                    >
                        Revenir à l'accueil
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
